import { render } from "./New_ItemChangeLogModal.vue?vue&type=template&id=00c070a0&scoped=true"
import script from "./New_ItemChangeLogModal.vue?vue&type=script&lang=js"
export * from "./New_ItemChangeLogModal.vue?vue&type=script&lang=js"

import "./New_ItemChangeLogModal.vue?vue&type=style&index=0&id=00c070a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c070a0"]])

export default __exports__